/**
 * Check if we have enough data about the customer for GiftAid:
 * - First initial
 * - Last name
 * - House number
 * - Postcode
 *
 * @param {Customer} customer
 *
 * @return {string[]}
 */
const customerGiftAidValidatonErrors = (customer) => {
    let contact = customer.getContact();
    let address = customer.getAddress();
    let missingFields = [];

    if (!contact.firstName) {
        missingFields.push('GIFT_AID_VALIDATION.FIRST_NAME_REQUIRED');
    }

    if (!contact.lastName) {
        missingFields.push('GIFT_AID_VALIDATION.LAST_NAME_REQUIRED');
    }

    if (!address.house) {
        missingFields.push('GIFT_AID_VALIDATION.HOUSE_REQUIRED');
    }

    if (!address.postcode) {
        missingFields.push('GIFT_AID_VALIDATION.POSTCODE_REQUIRED');
    }

    return missingFields;
};

module.exports = {
    customerGiftAidValidatonErrors,
};
